import { Heading, Subheading } from "../../../../../design/heading";
import { Divider } from "../../../../../design/divider";
import { useIntegration } from "../../../../../contexts/IntegrationContext";
import Breadcrumbs from "../../../../../components/Breadcrumbs";
import { Button } from "../../../../../design/button";
import DeleteIntegrationButton from "./components/DeleteIntegrationButton";
import { Avatar } from "../../../../../design/avatar";

const CLIO_CLIENT_ID = "s1TN8EGlsnwjrqRUgq9Lf6ljr3hSqUIgtINq6EW7";
const CLIO_REDIRECT_URI =
  "https://app.casetime.com/settings/integrations/callback/clio";

export default function ClioIntegrationPage() {
  const { integrations } = useIntegration();

  const clioIntegration = integrations.find(
    (integration) => integration._id === "clio",
  );
  return (
    <div>
      <Breadcrumbs
        items={[
          { label: "Settings", href: "/settings" },
          { label: "Integrations", href: "/settings/integrations" },
          { label: "Clio", href: "/settings/integrations/clio" },
        ]}
      />

      <div className="flex items-center gap-4">
        <Avatar
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTX0YbBllnistE3mPmu8ExuTVTA2vT92afJBQ&s"
          alt="Clio Logo"
          className="w-12 h-12"
        />
        <div className="flex flex-col gap-2">
          <Heading>Clio</Heading>
          <Subheading>Sync your Clio data with CaseTime</Subheading>
        </div>
      </div>

      <Divider className="my-4" />

      <div>
        {!clioIntegration && (
          <Button
            href={`https://app.clio.com/oauth/authorize?response_type=code&client_id=${CLIO_CLIENT_ID}&redirect_uri=${CLIO_REDIRECT_URI}`}
          >
            Integrate
          </Button>
        )}
        {clioIntegration && (
          <DeleteIntegrationButton integrationId={clioIntegration._id} />
        )}
      </div>
    </div>
  );
}
